
<div class="main">
  <div class="wrapper">
    <div class="global-head-column">
      <div class="global-head-row">
        <div class="page-title">FIBERHOOD CONTACT INFO</div>
        <div class="searchBar">
          <input
            type="text"
            pInputText
            size="20"
            placeholder="Global Filter"
            [(ngModel)]="globalFilter"
            style="margin-right: 10px"
          />
          <button
            class="AZ-button"
            disabled
            mat-stroked-button
            color="secundary"
          >
            <mat-icon class="searchIcon">search</mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="scroll-wrapper">
      <p-table
        #dt
        [columns]="cols"
        editMode="row"
        dataKey="areaId"
        [value]="tableData$() | async"
        [scrollable]="true"
        [scrollHeight]="getScrollHeight()"
      >
        <ng-template pTemplate="header" let-columns>
          <th
            *ngFor="let col of columns"
            [class.col--city]="col.field == 'city'"
            [class.col--fiberhood]="col.field == 'fiberHood'"
            [class.col--firstname]="col.field == 'firstName'"
            [class.col--lastname]="col.field == 'lastName'"
            [class.col--email]="col.field == 'email'"
            [class.col--phonenumber]="col.field == 'phoneNumber'"
          >
            <div class="status-flex">
              <div
                class="horizontal-flex"
                *ngIf="!checkSortIcon(col.field); else filterHeader"
              >
                {{ col.header }}
              </div>
              <ng-template #filterHeader>
                <div
                  class="horizontal-flex clickable"
                  [matMenuTriggerFor]="extendedFilter"
                  #menuTrigger="matMenuTrigger"
                >
                  {{ col.header }}
                  <ng-container
                    *ngIf="{
                      direction: (getFieldSort$(col.field) | async)
                    } as sort"
                  >
                    <mat-icon
                      class="sortIcon {{
                        sort.direction == 1
                          ? 'sort-ascending'
                          : 'sort-descending'
                      }}"
                      *ngIf="sort.direction"
                      >straight</mat-icon
                    >
                  </ng-container>
                  <mat-icon class="material-icons-outlined sortIcon"
                    >filter_alt</mat-icon
                  >
                  <ng-container
                    *ngIf="getFieldFilters$(col.field) | async as filters"
                  >
                    <span *ngIf="filters" class="clear-header-filters"
                      >({{ filters.length }})</span
                    >
                  </ng-container>
                </div>
                <mat-menu
                  class="column-filter-menu"
                  #extendedFilter="matMenu"
                  [hasBackdrop]="true"
                >
                  <app-column-filter
                    *ngIf="menuTrigger.menuOpen"
                    [values]="getFieldValues$(col.field) | async"
                    [template]="getFieldTemplate(col.field)"
                    [canSearch]="getFieldFilterSearch(col.field)"
                    [hasEmptyValue]="getFieldHasEmptyValue(col.field)"
                    [initialSelected]="getFieldFilters$(col.field) | async"
                    [initialSort]="getFieldSort$(col.field) | async"
                    [ignoredValues]="col.ignoredFilterValues"
                    (sort)="setSort(col.field, $event)"
                    (filter)="setFilter(col.field, $event)"
                    (closePopup)="menuTrigger.closeMenu()"
                  ></app-column-filter>
                </mat-menu>
              </ng-template>
            </div>
          </th>
          <th class="col--actions">
            <div class="clear-button">
              <button
                class="clear-button"
                mat-flat-button
                color="warn"
                (click)="clearAllFilter()"
                *ngIf="extendedFilterActive$ | async"
              >
                clear all
              </button>
            </div>
          </th>
        </ng-template>
        <ng-template
          pTemplate="body"
          let-areacontact
          let-editing="editing"
          let-ri="rowIndex"
          let-item
        >
          <tr [pEditableRow]="areacontact">
            <td class="col--city">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  {{ areacontact.city }}
                </ng-template>
                <ng-template pTemplate="output">
                  {{ areacontact.city }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="col--fiberhood">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  {{ areacontact.fiberHood }}
                </ng-template>
                <ng-template pTemplate="output">
                  {{ areacontact.fiberHood }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="col--firstname">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input
                    pInputText
                    type="text"
                    [(ngModel)]="areacontact.firstName"
                    required
                  />
                  <p
                    *ngIf="
                      hasValidationErrors &&
                      !isCorrectFirstName(areacontact.firstName)
                    "
                    style="color: red"
                  >
                    incorrect first name
                  </p>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ areacontact.firstName }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="col--lastname">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input
                    pInputText
                    type="text"
                    [(ngModel)]="areacontact.lastName"
                    required
                  />
                  <p
                    *ngIf="
                      hasValidationErrors &&
                      !isCorrectLastName(areacontact.lastName)
                    "
                    style="color: red"
                  >
                    incorrect last name
                  </p>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ areacontact.lastName }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="col--email">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input
                    pInputText
                    type="text"
                    [(ngModel)]="areacontact.email"
                    required
                  />
                  <p
                    *ngIf="
                      hasValidationErrors && !isCorrectEmail(areacontact.email)
                    "
                    style="color: red"
                  >
                    incorrect email
                  </p>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ areacontact.email }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="col--phonenumber">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input
                    pInputText
                    type="text"
                    [(ngModel)]="areacontact.phoneNumber"
                    required
                  />
                  <p
                    *ngIf="
                      hasValidationErrors &&
                      !isCorrectPhoneNumber(areacontact.phoneNumber)
                    "
                    style="color: red"
                  >
                    incorrect phone number
                  </p>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ areacontact.phoneNumber }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="col--awner">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-dropdown [options]="networkOwners" [(ngModel)]="areacontact.ownerId" optionLabel="name" optionValue="id" appendTo="body" required></p-dropdown>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ areacontact.ownerName }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="col--actions">
              <div class="chipBtns">
                <button
                  pInitEditableRow
                  *ngIf="!editing"
                  [disabled]="isTableInEditMode"
                  class="chip clickable"
                  [ngClass]="{
                    red:
                      uploadStates && areacontact.state == uploadStates.failed,
                    green:
                      uploadStates && areacontact.state == uploadStates.done
                  }"
                  mat-stroked-button
                  (click)="onRowEditInit(areacontact)"
                >
                  <mat-icon
                    class="material-icons-outlined"
                    *ngIf="
                      uploadStates && areacontact.state != uploadStates.ongoing
                    "
                    >edit</mat-icon
                  >
                  <mat-icon
                    class="material-icons-outlined"
                    *ngIf="
                      uploadStates && areacontact.state == uploadStates.ongoing
                    "
                    >autorenew</mat-icon
                  >
                </button>

                <button
                  *ngIf="!editing"
                  [disabled]="isTableInEditMode || !areacontact.firstName"
                  class="chip clickable"
                  [ngClass]="{
                    red:
                      uploadStates && areacontact.state == uploadStates.failed,
                    green:
                      uploadStates && areacontact.state == uploadStates.done
                  }"
                  mat-stroked-button
                  (click)="onRowDeleteInit(areacontact)"
                >
                  <mat-icon
                    class="material-icons-outlined"
                    *ngIf="
                      uploadStates && areacontact.state != uploadStates.ongoing
                    "
                    >delete</mat-icon
                  >
                  <mat-icon
                    class="material-icons-outlined"
                    *ngIf="
                      uploadStates && areacontact.state == uploadStates.ongoing
                    "
                    >autorenew</mat-icon
                  >
                </button>

                <button
                  pSaveEditableRow
                  *ngIf="editing"
                  class="chip clickable"
                  mat-stroked-button
                  (click)="onRowEditSave(areacontact)"
                >
                  <mat-icon class="material-icons-outlined">done</mat-icon>
                </button>

                <button
                  pCancelEditableRow
                  *ngIf="editing"
                  class="chip clickable"
                  mat-stroked-button
                  (click)="onRowEditCancel(areacontact)"
                >
                  <mat-icon class="material-icons-outlined">cancel</mat-icon>
                </button>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
